<template>
  <div>
    <div class="row">
      <b-button @click="nuevoDetalle" class="ml-2 btn-pill" size="xl" variant="primary">
        <i class="fa fa-plus"></i> Agregar detalle
      </b-button>
    </div>

    <br/>
    <h1>Detalles de Carga </h1>

    <div>
      <b-table small :fields="fields" :items="items" :per-page="perPage" :current-page="currentPage">

        <template slot="especificaciones" slot-scope="data">
          <b-col cols="12" sm="12" md="12" lg="12">
            <!-- <span v-for="item in data.item.specifications">
              {{ item.text }} ,
            </span> -->
          </b-col>
        </template>

        <template v-slot:cell(actions)="data">
          <b-col cols="12" sm="12" md="12" lg="12">
            <a href="#" @click.prevent="deleteDetalle(data.item)" title="Eliminar" class="text-danger"><i
              class="fa fa-close fa-lg mt-1 " style="color:red"></i></a>
          </b-col>
        </template>

        <template v-slot:cell(total)="data">
          ${{multiplication(data.item.price_box, data.item.quantity_boxes)}}
        </template>

      </b-table>

      <div class="overflow-auto">
        <div class="mt-3">
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"

            align="left"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          ></b-pagination>

        </div>


      </div>

      <div align="center">
        <b-card

          header-tag="header"
          align="center"
          footer-tag="footer"

        >

          <b-list-group flush>
            <b-list-group-item><b>Total Kilos Brutos:</b> {{total_gross_weight}} | <b>Total Kilos Netos:</b>
              {{total_net_weight}} | <b>Total Factura:</b> ${{totalAmount}}
            </b-list-group-item>
            <b-list-group-item><b>Total Cajas:</b> {{total_quantity_boxes}} |<b> Total Pallet:</b>
              {{total_pallet_quantity}}
            </b-list-group-item>
          </b-list-group>


        </b-card>
      </div>


    </div>


    <modalDetalleCarga ref="modalDetalleCarga" :boarding="boarding"></modalDetalleCarga>
  </div>
</template>

<script>
  import {bus} from "../../main";
  import modalDetalleCarga from './modalDetalleCarga.vue'
  import numeral from 'numeral'

  export default {
    name: "formDetalleCarga",
    components: {
      modalDetalleCarga,
    },
    props: [
      'boarding'
    ],
    data() {
      return {
        items: this.boarding.shipping_detail,
        total_gross_weight: 0,
        total_net_weight: 0,
        total_quantity_boxes: 0,
        total_pallet_quantity: 0,
        perPage: 5,
        currentPage: 1,
        fields: [
          {key: 'product.text', label: 'Producto'},
          {key: 'variety.text', label: 'Variedad'},
          {key: 'format.name', label: 'Formato'},
          {key: 'pallet_quantity', label: 'Numero Pallet'},
          {key: 'quantity_boxes', label: 'Cajas'},
          {key: 'price_box', label: 'Precio por cajas'},
          {key: 'gross_weight', label: 'Kilos Bruto'},
          {key: 'net_weight', label: 'Kilos Netos'},
          {key: 'especificaciones'},
          {key: 'total'},
          {key: 'actions'},
        ],

      }
    },
    created() {
      bus.$on('calcularDetalle', (nada) => {

        this.total_gross_weight = 0;
        this.total_net_weight = 0;
        this.total_quantity_boxes = 0;
        this.total_pallet_quantity = 0;

        for (var indice in  this.boarding.shipping_detail) {

          this.total_gross_weight += parseFloat(this.boarding.shipping_detail[indice].gross_weight);
          this.total_net_weight += parseFloat(this.boarding.shipping_detail[indice].net_weight);
          this.total_quantity_boxes += parseFloat(this.boarding.shipping_detail[indice].quantity_boxes);
          this.total_pallet_quantity += parseFloat(this.boarding.shipping_detail[indice].pallet_quantity);

        }

      });

    },
    mounted() {
      this.loadDataForm();
    },
    methods: {
      multiplication(a, b) {
        let value = numeral(a*b)
        return value.format('0,0.00')
      },
      nuevoDetalle() {

        this.$refs.modalDetalleCarga.modalShown = true;

      },
      deleteDetalle(row) {

        const index = this.boarding.shipping_detail.indexOf(row);
        this.boarding.shipping_detail.splice(index, 1);
        bus.$emit('calcularDetalle');

      },
      loadDataForm() {


      },

      submit() {

      },
    },
    computed: {
      totalAmount(){
        let value = this.items.reduce((acc, item) => acc + item.price_box * item.quantity_boxes, 0)
        value = numeral(value)
        return value.format('0,0.00')
      },
      rows() {
        return this.items.length
      },
    },
    beforeMount() {

    },
  }

</script>

<style scoped>

</style>
